import React from 'react';
import { AssetIcon } from '../../assets';

export default function MetricCard({
  label,
  value,
  icon: Icon,
  iconKey,
  tone = 'neutral',
  active = false,
  onClick,
}) {
  const interactive = typeof onClick === 'function';
  const Component = interactive ? 'button' : 'article';

  return (
    <Component
      type={interactive ? 'button' : undefined}
      className={[
        'wt-metric-card',
        `wt-metric-card--${tone}`,
        interactive ? 'wt-metric-card--interactive' : '',
        active ? 'is-active' : '',
      ].filter(Boolean).join(' ')}
      onClick={onClick}
      aria-pressed={interactive ? active : undefined}
    >
      <div className="wt-metric-card__copy">
        <p className="wt-metric-card__label">{label}</p>
        <p className="wt-metric-card__value">{value}</p>
      </div>
      {iconKey ? (
        <span className={`wt-metric-card__icon wt-metric-card__icon--${tone}`} aria-hidden="true">
          <AssetIcon name={iconKey} size={64} />
        </span>
      ) : Icon ? (
        <span className={`wt-metric-card__icon wt-metric-card__icon--${tone}`} aria-hidden="true">
          <Icon size={64} strokeWidth={1.65} />
        </span>
      ) : null}
    </Component>
  );
}
